shadow$provide[427] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `uniform float pointSize;

vec4 getSample(vec4 xyzw);

float getPointSize(vec4 xyzw) {
  return pointSize * getSample(xyzw).x;
}`;

};